import { Link } from 'react-router-dom';
import { usePortalPath } from '../../contexts/PortalContext';
import type { Client } from '../../types/crm';
import { accountTypeBadgeStyle, accountTypeShortLabel, formatClientSalespersonCode } from '../../utils/crmHelpers';
import { AccountAvatar } from './AccountAvatar';

interface AccountAccessDeniedProps {
  client: Client;
}

export function AccountAccessDenied({ client }: AccountAccessDeniedProps) {
  const accountsPath = usePortalPath('accounts');
  const badgeStyle = accountTypeBadgeStyle(client.client_type);
  const salesperson = formatClientSalespersonCode(client.owner_id);

  return (
    <div className="access-denied-page">
      <Link to={accountsPath} className="back-link">
        ← Accounts
      </Link>

      <div className="access-denied-panel">
        <div className="access-denied-panel__icon" aria-hidden>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 2a5 5 0 0 0-5 5v2H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-1V7a5 5 0 0 0-5-5Zm-3 7V7a3 3 0 1 1 6 0v2H9Z"
              fill="currentColor"
            />
          </svg>
        </div>

        <p className="access-denied-panel__eyebrow">Limited access</p>

        <div className="access-denied-panel__account">
          <AccountAvatar client={client} size="lg" className="access-denied-panel__avatar" />
          {client.client_type && (
            <span className="access-denied-panel__type" style={badgeStyle}>
              {accountTypeShortLabel(client.client_type)}
            </span>
          )}
          <h1 className="access-denied-panel__title">{client.company_name}</h1>
          <p className="access-denied-panel__code">{client.code}</p>
        </div>

        <div className="access-denied-panel__callout">
          <p className="access-denied-panel__callout-title">You cannot open this account</p>
          <p className="access-denied-panel__callout-text">
            This account is assigned to salesperson <strong className="mono">{salesperson}</strong>.
            Only users with that salesperson code (or Admin / IT / Management) can open full details.
          </p>
        </div>

        <ul className="access-denied-panel__hints">
          <li>Your list shows accounts that match your assigned salesperson code(s)</li>
          <li>Ask Admin Hub to assign the correct salesperson code on your profile</li>
        </ul>

        <div className="access-denied-panel__actions">
          <Link to={accountsPath} className="btn-primary">
            Back to accounts
          </Link>
        </div>
      </div>
    </div>
  );
}
